<template>
  <div :class="['scroll', { dark: isDark, hide: isHidden, show: !isHidden }]">
    <a href="#">
      <div class="progress">
        <div class="progress-bar" :style="scrollProgress"></div>
      </div>
      {{ t('Scroll To Top') }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.scroll {
  align-items: center;
  color: #222;
  display: flex;
  font-weight: 700;
  left: 1rem;
  position: fixed;
  top: 50%;
  transform-origin: left top;
  transform: rotate(-90deg) translate(-50%, 0);
  z-index: 10;

  &.dark {
    color: #fff;
  }

  a {
    align-items: center;
    color: inherit;
    display: flex;

    .progress {
      background: #ccc;
      border-radius: 0;
      height: 2px;
      margin-right: 1rem;
      transform: scaleX(-1);
      width: 60px;

      .progress-bar {
        background: $secondary;
        width: 10%;
      }
    }
  }

  @media (max-width: 767.98px) {
    display: none;
  }
}
</style>

<script>
import { useI18n } from 'vue-i18n';

export default {
  data() {
    return {
      isDark: true,
      isHidden: true,
      scrollProgress: 'width: 0%;'
    };
  },

  methods: {
    handleScroll: _.debounce(function () {
      var boundaryCache = 0,
        currentPosition = window.scrollY + window.innerHeight / 2;

      this.isHidden = window.scrollY < 100;
      this.scrollProgress = 'width: ' + ((window.innerHeight + window.scrollY) / document.body.scrollHeight) * 100 + '%;';
      this.isDark = Array.from(document.querySelectorAll('section'))
        .filter((section) => currentPosition >= boundaryCache && currentPosition < (boundaryCache = section.getBoundingClientRect().bottom + window.scrollY))[0]
        .classList.contains('dark');
    }, 50)
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  mounted() {
    this.handleScroll();
  },

  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          'Scroll To Top': 'Scroll To Top'
        },
        'zh-MY': {
          'Scroll To Top': '回到顶部'
        },
        'ms-MY': {
          'Scroll To Top': 'Tatal Ke Atas'
        }
      }
    });

    return { t };
  }
};
</script>
